<template>
    <div class="card-wrapper mb-4">
        <component :is="isMuted ? 'div' : 'a'" :href="shouldGoToUri" class="card course speaker" :class="{
            'muted': isMuted
        }">
            <div class="card-body">
                <div class="text-center img-wrap">
                    <img class="card-img-top-virtuoso h-auto" :src="speaker.imageUris ? speaker.imageUris.cardThumb.url : ''"
                        :alt="speaker.name"
                        loading="lazy"
                        width="320"
                        height="180">
                </div>

                <h2 class="card-title mb-0">{{ speaker.name }}</h2>

                <div class="card-text">
                    <p class="mb-0">{{ speaker.card_excerpt }}</p>
                </div>

                <div class="black-text mt-2" v-if="speaker.categoriesFormatted" v-html="speaker.categoriesFormatted"></div>
            </div>
        </component>
    </div>
</template>

<script>
    export default {
        props: {
            id: {
                type: Number,
                default: null
            },
            speakerData: {
                type: Object,
                default: null
            },
            muted: {
                type: Boolean,
                default: false
            }
        },

        data() {
            return {
                speaker: {},
                isMuted: false,
            }
        },

        computed: {
            shouldGoToUri: function () {
                return this.speaker.uri;
            }
        },

        mounted() {
            this.speaker = this.speakerData;

            // Prop option
            if(this.muted === true) {
                this.isMuted = true;
            }
        },

        methods: {
        }
    }
</script>
